import { createClient } from "@supabase/supabase-js";

// Check process.env first (populated via vite.config.js define), then import.meta.env
const supabaseUrl =
  process.env.SUPABASE_URL || import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey =
  process.env.SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY;

console.log("Supabase Init Debug:", {
  url: supabaseUrl ? "Found" : "Missing",
  key: supabaseAnonKey ? "Found" : "Missing",
  env: import.meta.env.MODE,
});

// Create client only if credentials exist to prevent crash
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Supabase Credentials Missing! Application cannot start. Please check your .env file or deployment settings (VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY).",
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: "pkce",
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Keep auth session out of localStorage to reduce XSS persistence risk.
    storage:
      typeof window !== "undefined" ? window.sessionStorage : undefined,
  },
});
